import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";

export default function PageHero({ eyebrow, title, lede, breadcrumb = [] }) {
  return (
    <section className="relative pt-24 pb-16 sm:pt-28 sm:pb-20 overflow-hidden theme-section-alt">
      <div className="absolute inset-0 dot-grid opacity-30" />
      <div className="absolute -top-32 right-1/4 w-[500px] h-[500px] bg-[#00C2FF] rounded-full blur-[200px] opacity-15" />

      <div className="max-w-7xl mx-auto px-6 relative">
        <motion.nav
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs font-mono uppercase tracking-[0.2em] theme-muted mb-10"
          data-testid="page-breadcrumb"
        >
          <Link to="/" className="hover:text-[#00C2FF] transition-colors">Home</Link>
          {breadcrumb.map((b, i) => (
            <React.Fragment key={i}>
              <ChevronRight className="w-3 h-3" />
              {b.path ? (
                <Link to={b.path} className="hover:text-[#00C2FF] transition-colors">
                  {b.label}
                </Link>
              ) : (
                <span className="text-[#00C2FF]">{b.label}</span>
              )}
            </React.Fragment>
          ))}
        </motion.nav>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl"
        >
          {eyebrow && (
            <div className="flex items-center gap-3 mb-5">
              <span className="w-12 h-px bg-[#00C2FF]" />
              <span className="font-mono text-[11px] uppercase tracking-[0.4em] text-[#00C2FF] font-bold">
                / {eyebrow}
              </span>
            </div>
          )}
          <h1
            data-testid="page-title"
            className="font-display text-3xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tighter theme-heading"
          >
            {title}
          </h1>
          {lede && (
            <p className="theme-muted mt-5 text-base sm:text-lg leading-relaxed max-w-3xl">
              {lede}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
}
